import { IdleSessionTimeout } from "idle-session-timeout";

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.idletimeout = abcsetup.idletimeout || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.idletimeout.session = null;



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    $(document).on('click', '#timeout-modal .btn-logout', function () {
        document.getElementById('logout-form').submit();
    });

    $(document).on('click', '#timeout-modal .btn-continue', function () {
        abcsetup.idletimeout.session.reset();
    });

    abcsetup.idletimeout.init();
});



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.idletimeout = {
    init: function() {
        // Timeout durations
        const TIMEOUTS = {
            STANDARD: 20 * 60 * 1000, // 20 minutes
            EXTENDED: 60 * 60 * 1000  // 60 minutes
        };

        // List of roles with extended idle timeout
        const extendedTimeoutRoles = new Set([
            'set_analyst',
            'pricing_supervisor',
            'cp_vp',
            'set_340b_analyst',
            'set_340b_supervisor',
            'set_cb_analyst',
            'set_cb_supervisor',
        ]);

        // Determine timeout duration based on user role
        const timeoutDuration = extendedTimeoutRoles.has(abcsetup.userRole?.class)
            ? TIMEOUTS.EXTENDED
            : TIMEOUTS.STANDARD;

        // Initialize idle session timeout
        abcsetup.idletimeout.session = new IdleSessionTimeout(timeoutDuration);

        // Session has timed out because of inactivity
        abcsetup.idletimeout.session.onTimeOut = () => {
            document.getElementById('logout-form').submit();
        };

        abcsetup.idletimeout.session.onTimeLeftChange = (timeLeft) => {
            if (!abcsetup.guest) {
                var seconds = Math.ceil(timeLeft / 1000);
                $("#timeout-modal").find('#seconds_remain').html(seconds);

                // We have less than 60 seconds left before we're timed out
                if ((timeLeft / 1000) < 60) {
                    $("#timeout-modal").modal({backdrop: 'static', keyboard: false})
                } else {
                    $("#timeout-modal").modal('hide');
                }
            }
        };

        abcsetup.idletimeout.session.start();
    },
}
